// src/components/includes/AnimatedCounts.jsx
import React, { useEffect, useRef, useState } from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import styles from './AnimatedCounts.module.css';

const AnimatedCounts = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Animation will only trigger once
    threshold: 0.5,    // Trigger when 50% of the component is visible
  });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (inView && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [inView, hasAnimated]);

  const countItems = [
    { end: 3500, label: 'Students' },
    { end: 25, label: 'Trending Courses' },
    { end: 15, label: 'Expert Trainers' },
    { end: 200, label: 'Hiring Partners' },
  ];

  return (
    <section className={styles.countsSection} ref={ref}>
      <div className={styles.container}>
        <div className={styles.row}>
          {countItems.map((item, index) => (
            <div className={styles.col} key={index}>
              <div className={styles.counterItem}>
                {hasAnimated && (
                  <CountUp
                    start={0}
                    end={item.end}
                    duration={2.5}
                    separator=","
                    className={styles.count}
                    // Add a delay for each item for a staggered effect
                    delay={index * 0.2}
                  />
                )}
                <p className={styles.label}>{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AnimatedCounts;